export default __webpack_public_path__ + "media/quote.fcb78bab.svg";